import { forwardRef } from 'react';
import * as S from './styles';

interface Props {
  defaultValue: string;
  placeholder: string;
}

export const Search = forwardRef<HTMLInputElement, Props>(function SearchComponent(
  { placeholder, defaultValue },
  ref,
) {
  return (
    <S.InputWrapper>
      <S.SearchIcon name="search" useCurrentColor />
      <S.Input
        data-testid="search-input"
        placeholder={placeholder}
        autoComplete="off"
        autoCorrect="off"
        defaultValue={defaultValue}
        ref={ref}
      />
    </S.InputWrapper>
  );
});
